// navbar icons
import tick from '@/public/BlogDetails/tick@2x.png'
import checkedIcon from '@/public/BlogDetails/Check.svg'
export {
    tick,
    checkedIcon,
}